import React from "react";
import MainRouter from "features/router/MainRouter";

function App() {
  return <MainRouter />;
}

export default App;
